import { useState } from 'react';
import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import DataTabs from '@rio-cloud/rio-uikit/DataTabs';
import DataTab from '@rio-cloud/rio-uikit/DataTab';
import useScoreExtractStore from '../services/scoreExtractStore';
import { useNavigate } from 'react-router';
import { useSelectVehicleStore } from '../services/selectVehicleSlice';
import DashboardTableAnalysis from '../features/dashboardTableAnalysis/DashBoardTableAnalysis';
import TableViewToggles from '@rio-cloud/rio-uikit/components/table/TableViewToggles';
import DashboardTableInfractions from '../features/dashboardTableInfractions/DashboardTableInfractions';
import { RouteMap } from '../routes/routeList';


const Title = ({ text, icon, value }: { text: string; icon: React.ReactNode, value: React.ReactNode }) => (
    <div>
        <div>{text}</div>
        <div className='text-bold text-size-18'><span className={`rioglyph ${icon} margin-right-10`}></span>{value}</div>
    </div>
);

export default function Esg() {

    const [tabKey, setTabKey] = useState<string>('');
    const { clearExtractScoreData } = useScoreExtractStore();
    const { clearSelectedVehicle } = useSelectVehicleStore();
    const navigate = useNavigate();
    const { selectedVehicle } = useSelectVehicleStore();
    const behaviorType = 'ESG';
    const behaviorRoute = `/${RouteMap.get('behavior')}`;
    
    const tabs = [
        {
            key: 'IT_EXTRACT',
            icon: 'rioglyph-clipboard',
            title: 'Sustentável',
            value: 'Análise por Evento',
            hasData: true
        },
        {
            key: 'IT_IDLING',
            icon: 'rioglyph-delivery-completed',
            title: 'Marcha Lenta',
            value: `${selectedVehicle.itIdling || 0} Ocorrências`,
            hasData: selectedVehicle.itIdling ? Number(selectedVehicle.itIdling) > 0 : false
        },
        {
            key: 'IT_IDLING_AC',
            icon: 'rioglyph-cooling',
            title: 'Climatização evitada com veículo parado',
            value: `${selectedVehicle.itIdlingAc || 0} Ocorrências`,
            hasData: selectedVehicle.itIdlingAc ? Number(selectedVehicle.itIdlingAc) > 0 : false
        },
    ];

    return (
        <StatsWidgets>
            <StatsWidget>
                <StatsWidget.Header className='text-left text-size-16'>
                    <ul className="breadcrumb">
                        <li>
                            <span className="btn btn-link btn-link-inline">
                                <span className="rioglyph rioglyph-home margin-right-0">
                                </span>
                                <span className='margin-left-10'>
                                    <a onClick={() => {
                                        clearExtractScoreData();
                                        clearSelectedVehicle();
                                        navigate(behaviorRoute);
                                    }}>Comportamento</a>
                                </span>
                            </span>
                        </li>
                        <li className="active">Sustentávelㅤ-ㅤ<span className='text-bold'>{ selectedVehicle.name }</span></li>
                    </ul>
                </StatsWidget.Header>
                <StatsWidget.Body>
                    <DataTabs activeKey={tabKey} onSelectTab={newTabKey => setTabKey(newTabKey)}>
                        {tabs.map((tab, index) => {
                            if (index === 0) {
                                return (
                                    <DataTab key={index} active={true} tabKey={tab.key} title={<Title text={tab.value} icon={tab.icon} value={tab.title} />}>
                                        <DashboardTableAnalysis viewType={TableViewToggles.VIEW_TYPE_TABLE} behaviorType={behaviorType} />
                                    </DataTab>
                                )
                            } else {
                                return (<DataTab key={index} tabKey={tab.key} title={<Title text={tab.value} icon={tab.icon} value={tab.title} />}>
                                    <DashboardTableInfractions viewType={TableViewToggles.VIEW_TYPE_TABLE} hasData={tab.hasData} infractionName={tab.key} tabName={tab.title}/>
                                </DataTab>)
                            }
                        })}
                    </DataTabs>
                </StatsWidget.Body>
            </StatsWidget>
        </StatsWidgets>
    );
}